import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { FundraisingInfo } from "../../../../api/types/fundraisingTypes";
import type { FundraisingStatusTransition } from "./fundraisingsPageTypes";

export interface Props {
  hasEditPermissions: boolean;
  onCreate: () => void;
  onRename: (id: string, name: string, etag: string) => void;
  onStatusChange: (fundraising: FundraisingInfo, statusTransition: FundraisingStatusTransition) => void;
  onDelete: (id: string, name: string) => void;
}

export const FundraisingsPageContext = createContext<Props | undefined>(undefined);

export const useFundraisingsPageContext = () =>
  defined(use(FundraisingsPageContext), "Attempt to use FundraisingsPageContext without provider");
